import type React from 'react';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import {
	iconThumbDownNofill20Px,
	iconThumbDownNofill24Px,
	iconThumbsDownFill20Px,
	iconThumbsDownFill24Px,
	iconThumbsUpFill20Px,
	iconThumbsUpFill24Px,
	iconThumbUpNofill20Px,
	iconThumbUpNofill24Px,
} from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';

import {
	type PlatformType,
	type Recommendation,
	useShareRecommendationsTracking,
} from '../../hooks/useShareRecommendationsTracking';

type FeedbackVoterProperties = {
	recommendation: Recommendation;
	type: PlatformType;
};

const color = '#707070';

export const FeedbackVoter: React.FC<FeedbackVoterProperties> = ({ recommendation, type }) => {
	const { actions } = useShareRecommendationsTracking();

	return (
		<>
			<Box
				sx={{
					display: ['flex', 'none'],
					flexGrow: 1,
					textAlign: 'right',
					width: '72px',
					justifyContent: 'flex-end',
					alignSelf: 'flex-end',
				}}
			>
				<Icon
					data-testid="vote-up-button"
					data-qa="vote-up-button"
					size="xxl"
					color={color}
					icon={actions.isVoted('like') ? iconThumbsUpFill24Px : iconThumbUpNofill24Px}
					onClick={() => actions.handleVoteUp(recommendation)}
					sx={{ width: '40px', marginRight: 16 }}
				/>
				<Icon
					data-testid="vote-down-button"
					data-qa="vote-down-button"
					size="xxl"
					color={color}
					icon={actions.isVoted('dislike') ? iconThumbsDownFill24Px : iconThumbDownNofill24Px}
					onClick={async () => actions.handleVoteDown(recommendation, type)}
					sx={{ width: '40px' }}
				/>
			</Box>
			<Box
				sx={{
					display: ['none', 'flex'],
					flexGrow: 1,
					width: '56px',
					justifyContent: 'flex-end',
				}}
			>
				<Icon
					data-testid="vote-up-button"
					data-qa="vote-up-button"
					size="xl"
					color={color}
					icon={actions.isVoted('like') ? iconThumbsUpFill20Px : iconThumbUpNofill20Px}
					onClick={() => actions.handleVoteUp(recommendation)}
					sx={{ marginRight: 16 }}
				/>
				<Icon
					data-testid="vote-down-button"
					data-qa="vote-down-button"
					size="xl"
					color={color}
					icon={actions.isVoted('dislike') ? iconThumbsDownFill20Px : iconThumbDownNofill20Px}
					onClick={async () => actions.handleVoteDown(recommendation, type)}
				/>
			</Box>
		</>
	);
};
